export const QUALIFIERS=[
  "You're still learning how to close. This fixes pipeline,not fundamentals.",
  "You want cheap,shared,third-hand leads. We don't sell those.",
  "You treat the investment as an expense instead of what it actually is — leverage.",
  "A lead sits for two days before you call it back.",
  "You expect us to close the deal for you. We won't,and honestly,we can't.",
  "You expect us to answer your Marketplace inbox for you. That's yours — always has been.",
  "You're comfortable finishing the month in the middle of the board."
];

export const SERVICES=[
  {
    number: "01",
    title: "Social Media Manager",
    body: "Posts 15 fresh Marketplace listings every week,so buyers see new inventory with your name on it — without you touching a listing.",
    icon: "FiMonitor"
  },
  {
    number: "02",
    title: "Outreach Team",
    body: "Works up to 500 of your past leads and customers,reactivating the ones ready to buy,sell,or trade again — without you typing a single text.",
    icon: "FiUsers"
  },
  {
    number: "03",
    title: "Follow-Up Assistant",
    body: "Handles up to 5 call and text follow-ups a day on your behalf,so nobody in your pipeline goes quiet.",
    icon: "FiPhoneCall"
  }
];

export const PROOF_SLOTS=[
  {
    quote: '"[Producer name] reactivated [X] past customers into new appointments in their first 30 days.]"',
    detail: "— [Name],[Title,Market]"
  },
  {
    quote: '"[Insert the math: cost of the Suite vs. revenue from deals closed off it — let the number make the argument.]"',
    detail: "— [Name],[Title,Market]"
  },
  {
    quote: '"[Insert what changed for them month over month — board position,deals closed,hours saved.]"',
    detail: "— [Name],[Title,Market]"
  }
];

const packageFeatures=[
  "Social Media Manager: 15 listings/week",
  "Outreach Team: up to 500 past leads worked",
  "Follow-Up Assistant: up to 5 requests/day"
];

export const SEATS=[
  {
    tier: "Month-to-Month",
    name: "Flexible Plan",
    price: "$750/month",
    audience: "Same team,same deliverables. Cancel anytime.",
    features: packageFeatures,
    button: "Apply for This Plan",
    bookingUrl: "https://pfnl.co/t1kxcgj"
  },
  {
    tier: "3-Month Commitment · Best Value",
    name: "Commitment Plan",
    price: "$650/month",
    audience: "Same team,same deliverables. Three-month agreement required.",
    features: packageFeatures,
    button: "Apply for This Plan",
    bookingUrl: "https://pfnl.co/6t74xvs",
    featured: true
  }
];